<div class="product-categories-responsive p-g-12">
   <div class="p-g-12">

      <div class="p-g">

         <div class="p-g-12 p-table-tecfolk-fix">

            <p-table [value]="categories" [rowHover]="true" [paginator]="true" [rows]="10" [responsive]="true"
               [loading]="loading" [first]="first" (onPage)="onPageChange($event)">

               <ng-template pTemplate="caption" style="text-align: left; background-color: #2f4050 !important;">
                  <div class="reportMainFilter">
                     <div class="reportMainFields">
                        <div class="filterFields">
                           <span class="fieldTitle">{{setLabel("searchByNameLabel")}}</span>
                           <input id="searchName" #searchName
                              style=" color: black ; height:30px ;outline: none; box-shadow: none; margin-right: 8px;"
                              autocomplete="off" pinputtext="" (keyup)="searchLocal(category.name, 'name')"
                              [(ngModel)]="category.name" [placeholder]='setLabel("searchHerePlaceholderLabel")'
                              type="text" name="name" class="p-inputtext p-corner-all p-state-default p-widget">
                        </div>
                        <div class="reportMainBtn">
                           <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear" [disabled]="loading"
                              (click)="clear()"> <i class="pi pi-times"></i></span>
                        </div>
                     </div>
                     <div class="reportMainBtn">
                        <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear hideOnLaptop"
                           [disabled]="loading" (click)="clear()"> <i class="pi pi-times"></i></span>

                        <span [pTooltip]='setLabel("addNewTooltipLabel")' tooltipPosition="top"
                           routerLink="/product-category" class="iconClear " [disabled]="loading"> <i
                              class="pi pi-user-plus"></i></span>
                     </div>
                  </div>

                  <!-- <div class="search-Bar-Main">

                     <div>
                        <input id="searchName" #searchName
                           style=" color: black ; height:30px ;outline: none; box-shadow: none; margin-right: 8px;"
                           autocomplete="off" pinputtext="" (keyup)="searchLocal(category.name, 'name')"
                           [(ngModel)]="category.name" placeholder="Search By Name" type="text" name="name"
                           class="p-g-12 ng-pristine ng-valid ng-touched">
                     </div>
                     <div class="search-Bar-Button">
                        <button pButton type="button" class="p-button p-widget p-state-default p-corner-all"
                           (click)="clear()" style="background-color: rgb(38, 223, 183); " label="Clear Search">
                        </button>

                        <button routerLink="/product-category" pButton type="button"
                           class=" p-button p-widget p-state-default p-corner-all productCategoriesButtons"
                           style="background-color: rgb(66, 66, 204);" label="Add New">
                        </button>
                     </div>
                  </div> -->

               </ng-template>

               <ng-template pTemplate="header">
                  <tr>
                     <th style="max-width: 90px;">{{setLabel("nameLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("descriptionLabel")}}</th>
                     <th style="max-width: 130px; text-align: center;">{{setLabel("actionsLabel")}}</th>
                  </tr>
               </ng-template>

               <ng-template pTemplate="body" let-rowData>
                  <tr (click)="viewCategory(rowData)" class="p-selectable-row">
                     <td class="product-categories-td">
                        <div class="mobile-Lable">{{setLabel("nameLabel")}}</div>

                        {{rowData.name}}
                     </td>
                     <td class="product-categories-td">
                        <div class="mobile-Lable">{{setLabel("descriptionLabel")}}</div>

                        {{rowData.description}}
                     </td>
                     <td class="product-categories-td" style="text-align: center;">
                        <div class="mobile-Lable" style="text-align: justify;">{{setLabel("actionsLabel")}}</div>

                        <button pButton type="button" [pTooltip]='setLabel("deleteCategoryTooltipLabel")'
                           tooltipPosition="top" class="p-button-danger p-button-danger p-button" icon="fa fa-times"
                           (click)="deleteCategory(rowData)" style="margin-right: 5px;">
                        </button>
                        <button pButton type="button" [pTooltip]='setLabel("editCategoryTooltipLabel")'
                           tooltipPosition="top" icon="fa fa-pencil-square-o" (click)="viewCategory(rowData)"
                           style="margin-right: 5px;">
                        </button>
                     </td>
                  </tr>
               </ng-template>

               <ng-template pTemplate="emptymessage" let-columns>
                  <tr style="color: black;">
                     <td>
                        {{setLabel("noRecordFoundLabel")}}
                     </td>
                  </tr>
               </ng-template>

            </p-table>
         </div>
      </div>
   </div>
</div>